import { Box, Skeleton, Typography } from '@mui/material'

type PageHeaderProps = {
  header: string
  subHeader?: string
  children?: React.ReactNode
}

const PageHeaderComponent: React.FC<PageHeaderProps> = ({
  header,
  subHeader,
  children,
}: PageHeaderProps) => {
  return (
    <Box className="page-title-box">
      <Box>
        <Typography variant="h1DMSansBold" display="block" color="#1B2064">
          {header}
        </Typography>
        {subHeader && (
          <Typography variant="DMSansHeaderSecondary">
            {subHeader ?? <Skeleton width={300} height={30} variant="text"></Skeleton>}
          </Typography>
        )}
      </Box>
      <Box sx={{display:"flex", alignItems: 'center', justifyContent: 'space-around', gap: 1}}>
      {children}

      </Box>
    </Box>
  )
}

export default PageHeaderComponent
